import { atom, createStore } from 'jotai';

type navigationEntry = {
  value: () => void;
  baseRoute: string;
};

const navigationBackButtonAtom = atom<navigationEntry[] | []>([]);
navigationBackButtonAtom.debugLabel = 'navigationBackButtonAtom';

const navigationBackbuttonStore = createStore();

const headerBackButtonContainerRefAtom = atom<React.RefObject<HTMLDivElement> | null>(null);

export { headerBackButtonContainerRefAtom, navigationBackButtonAtom, navigationBackbuttonStore };
